export interface ILeadFormConstants {
    pageTitle: string;
    heading: string;
    subHeading: string;
}

export const RouteValues = {
    ACCEPT_DEAL: '/acceptDeal',
    CREDIT: '/credit',
    CREDIT_DECISION_RESULTS: '/creditDecisionResults',
    COUNTER_OFFER: '/counterOffer',
    DEAL_CERTIFICATE: '/dealCertificate',
    DEAL_CERTIFICATE_DEALER_VIEW: '/dealCertificateDealerView',
    DEAL_SUMMARY: '/dealSummary/default',
    DEALER_OFFER: '/dealerOffer',
    DEALER_OFFER_SUMMARY: '/dealerOfferSummary',
    EDIT_TERMS: '/paymentOptions/edit',
    HELP_CONTACT: '/helpContact',
    INCENTIVES: '/incentives',
    LANDING_PAGE: '/landingPage',
    LEAD_FORM: '/leadForm',
    MENU_PRODUCTS: '/menuProducts',
    MESSAGING: '/messaging',
    MY_TERMS_DEAL_SUMMARY: '/dealSummary/myTerms',
    PROTECTION_LIST: '/protectionList',
    RESERVATION: '/reservation',
    SOFT_PULL: '/softPull',
    SUMMARY_LEAD_FORM: '/summaryLeadForm',
    LANDING_INTERSTITIAL: '/landingInterstitial',
    TERMS: '/paymentOptions',
    TEST_DRIVE: '/testDrive',
    TRADE_EQUITY: '/equity',
    TRADE_IN: '/tradeIn',
    TRADE_IN_LEADFORM: '/tradeLeadForm',
    VEHICLE_INFO: '/vehicleInfo',
    TRADE_IN_SEARCH: '/tradeInSearch',
    TRADE_IN_SUMMARY: '/tradeSummary',
    DASHBOARD: '/dashboard',
    DEAL_SUMMARY_PAGE: '/dealsummarypage',
    TRADE_IN_ICO_SUCCESS: '/tradeInIcoSuccess'
};
